import { render, staticRenderFns } from "./ContactWe.vue?vue&type=template&id=4effa3a6&scoped=true&"
import script from "./ContactWe.vue?vue&type=script&lang=js&"
export * from "./ContactWe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4effa3a6",
  null
  
)

export default component.exports